// extracted by mini-css-extract-plugin
export default {"fill":"MonetaryProgressCircle_fill__-BbfO","outline":"MonetaryProgressCircle_outline__ZGgeq"};